<template>
  <div class="row m-t-lg">
    <div class="col-xs-12 col-sm-6">
      <div class="checkbox checkbox-primary">
        <input id="check-notify-email" class="styled" type="checkbox" v-model="notifyJobStatus" />
        <label for="check-notify-email">
          Notify me of job status updates
        </label>
      </div>
    </div>
    <div class="col-xs-12 col-sm-6">
      <div class="checkbox checkbox-primary">
        <input id="check-notify-email-delivery" class="styled" type="checkbox" v-model="notifyLoadDeliveries" />
        <label for="check-notify-email-delivery">
          Notify me of load deliveries
        </label>
      </div>
    </div>
    <div class="col-xs-12 col-sm-6">
      <div class="checkbox checkbox-primary">
        <input id="check-notify-job-completed" class="styled" type="checkbox" v-model="notifyJobCompleted" />
        <label for="check-notify-job-completed">
          Notify me of invoices and payments
        </label>
      </div>
    </div>
    <div class="col-xs-12 col-sm-6">
      <div class="checkbox checkbox-primary">
        <input id="check-notify-children" class="styled" type="checkbox" v-model="notifyChildren" />
        <label for="check-notify-children">
          Apply notification settings to other users in our organisation (if I have any)
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  import { SET_JOB_ATTRIBUTE } from 'vx/mutations'
  import { stateMapper } from 'mixins/jobs'

  export default {
    mixins: [stateMapper],

    computed: {
      ...mapState('job', ['job']),

      notifications () {
        return {
          notify_job_status: this.notifyJobStatus,
          notify_load_deliveries: this.notifyLoadDeliveries,
          notify_job_completed: this.notifyJobCompleted,
          notify_children: this.notifyChildren
        }
      }
    },

    watch: {
      notifyJobStatus (newValue, oldValue) {
        this.handleUpdateNotifications(newValue, oldValue)
      },
      notifyLoadDeliveries (newValue, oldValue) {
        this.handleUpdateNotifications(newValue, oldValue)
      },
      notifyJobCompleted (newValue, oldValue) {
        this.handleUpdateNotifications(newValue, oldValue)
      },
      notifyChildren (newValue, oldValue) {
        this.handleUpdateNotifications(newValue, oldValue)
      }
    },

    methods: {
      ...mapActions('job', ['updateNotifications']),
      ...mapMutations('job', [SET_JOB_ATTRIBUTE]),

      /**
       * Handle updating the jobs notifications.
       *
       * @param boolean newValue
       * @param boolean oldValue
       *
       * @return void
       */
      handleUpdateNotifications (newValue, oldValue) {
        if (newValue === oldValue) {
          return
        }

        this.updateNotifications({ id: this.job.id, payload: this.notifications })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Notifications.vue?15262834